var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "featured-header" }, [
    _c(
      "div",
      {
        staticClass: "visu-wrapper",
        class: { p: _vm.vidPlaying },
        style: _vm.reelStyle,
      },
      [
        _c("div", { staticClass: "vid-container" }, [
          _c(
            "video",
            {
              ref: "player",
              attrs: {
                width: "1680",
                height: "944",
                playsinline: "",
                autoplay: "",
                loop: "",
                muted: "",
              },
              domProps: { muted: true },
            },
            [_c("source", { attrs: { type: "video/mp4", src: _vm.videoURL } })]
          ),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "pic cvr",
          style: { backgroundImage: "url(" + _vm.asset.poster + ")" },
        }),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mask", style: _vm.maskStyle }),
    _vm._v(" "),
    _c("div", { staticClass: "container n-mx" }, [
      _c("div", { staticClass: "col infos" }, [
        _c("h1", { style: { color: _vm.Global.mockupConfig.colors.icons } }, [
          _vm._v(_vm._s(_vm.asset.name)),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "desc" }, [
          _vm._v(_vm._s(_vm.asset.description)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "actns" }, [
          _vm.asset.planIndex != 0
            ? _c(
                "div",
                {
                  staticClass: "btn main ply sub",
                  style: { background: _vm.Global.mockupConfig.colors.icons },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.openSubOverlay.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "ico" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "21",
                          height: "24",
                          viewBox: "0 0 21 24",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z",
                            fill: "black",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "txt" }, [_vm._v("Subscribe")]),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "btn main ply",
                  style: { background: _vm.Global.mockupConfig.colors.icons },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.play.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "ico" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "21",
                          height: "24",
                          viewBox: "0 0 21 24",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z",
                            fill: "black",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.asset.progressPerc
                    ? _c("span", { staticClass: "txt" }, [_vm._v("Resume")])
                    : _c("span", { staticClass: "txt" }, [_vm._v("Play")]),
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn lgt inf",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.show.apply(null, arguments)
                },
              },
            },
            [
              _c("span", { staticClass: "ico" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "26",
                      height: "26",
                      viewBox: "0 0 26 26",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM15 7C15 8.10457 14.1046 9 13 9C11.8954 9 11 8.10457 11 7C11 5.89543 11.8954 5 13 5C14.1046 5 15 5.89543 15 7ZM14.5 12C14.5 11.1716 13.8284 10.5 13 10.5C12.1716 10.5 11.5 11.1716 11.5 12V19C11.5 19.8284 12.1716 20.5 13 20.5C13.8284 20.5 14.5 19.8284 14.5 19V12Z",
                        fill: "white",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "txt" }, [_vm._v("More info")]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rgt" }, [
        !_vm.vidPlaying
          ? _c("div", { staticClass: "sqr spn" }, [
              _c("span", { staticClass: "ico" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "29",
                      height: "29",
                      viewBox: "0 0 29 29",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M2 14.5003C1.99993 11.5785 3.02338 8.749 4.89257 6.50331C6.76177 4.25762 9.35858 2.73768 12.2319 2.20752C15.1052 1.67736 18.0735 2.17049 20.621 3.60124C23.1685 5.03199 25.1344 7.30995 26.177 10.0394C27.2197 12.7688 27.2732 15.7773 26.3284 18.5421C25.3836 21.307 23.5001 23.6535 21.0051 25.174C18.5101 26.6945 15.5613 27.293 12.6709 26.8655C9.78056 26.4379 7.13128 25.0114 5.18333 22.8337",
                        stroke: "white",
                        "stroke-width": "3",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
              ]),
            ])
          : _c(
              "div",
              {
                staticClass: "sqr vol",
                class: { mtd: _vm.isMuted },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleMute.apply(null, arguments)
                  },
                },
              },
              [
                _c("span", { staticClass: "ico" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "35",
                        height: "23",
                        viewBox: "0 0 35 23",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M6.5 6.91867H3.33333C2.59733 6.91867 2 7.516 2 8.252V14.5853C2 15.3213 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4133C12.672 21.148 14 20.532 14 19.396V3.44133C14 2.30533 12.6707 1.68933 11.8053 2.424L6.5 6.91867Z",
                          fill: "white",
                          stroke: "white",
                          "stroke-width": "1",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "vol-bar",
                        attrs: {
                          d: "M19.3827 16.7227C20.932 15.76 22 13.7573 22 11.4253C22 9.09333 20.932 7.08933 19.3827 6.11467",
                          stroke: "white",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "vol-bar",
                        attrs: {
                          d: "M23.34 20.8387C25.7507 18.7653 27.3333 15.3253 27.3333 11.4227C27.3333 7.51467 25.748 4.072 23.3333 2",
                          stroke: "white",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          width: "3",
                          height: "15",
                          rx: "1.5",
                          transform:
                            "matrix(0.707103 0.70711 -0.707103 0.70711 27.8491 5.24249)",
                          fill: "white",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          width: "3",
                          height: "15",
                          rx: "1.5",
                          transform:
                            "matrix(0.707107 -0.707107 0.707114 0.7071 17.2427 7.36389)",
                          fill: "white",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }